import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const NominalCostOfSale = {
  type: 'MinMaxCalculationParametersInput',
  formTitle: 'Nominal Cost Of Sale',
  formUrl: '/Nominal/CostOfSale/Form',
  fragment,
  screenReference: 'NOMINAL_COSTSALE',
  formReturnUrl: '/menu/Nominal',
  operations: 0,
};

export default NominalCostOfSale;
